import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    if (user.password_change_required === 1) {
      return <Navigate to={PATH_AUTH.changePassword} />;
    }

    // todo subscription expired

    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
